import { render, staticRenderFns } from "./UserInviteModal.vue?vue&type=template&id=5f876796&scoped=true&"
import script from "./UserInviteModal.vue?vue&type=script&lang=js&"
export * from "./UserInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f876796",
  null
  
)

export default component.exports